// extracted by mini-css-extract-plugin
module.exports = {"resource":"resource_resource-1Cyzm","number":"resource_number-3ajRO","item":"resource_item-3XDbD"};